// This file is generated by bin/generate-theme.ts

// Radius design tokens
export const radii = {
  s: '4px',
  m: '6px',
  l: '8px',
  full: '100px',
};

export type RadiiTokens = typeof radii;
export type RadiiKey = keyof RadiiTokens;
